import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class PredictionSummary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "showDetails", false);
  }
  getPredictionResults(award, categories) {
    const currentUserId = app.session.user?.id();
    const userVotes = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      return !vUserId || String(vUserId) === String(currentUserId);
    });
    const results = [];
    categories.forEach(category => {
      const categoryId = category.id();
      const nominees = category.nominees() || [];

      // Find user's vote for this category
      const userVote = userVotes.find(v => {
        const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
        return String(vCategoryId) === String(categoryId);
      });
      let userVotedNominee = null;
      if (userVote) {
        const vNomineeId = userVote.nomineeId?.() || userVote.data?.relationships?.nominee?.data?.id;
        userVotedNominee = nominees.find(n => String(n.id()) === String(vNomineeId)) || null;
      }

      // Find winner (nominee with highest vote count)
      const winner = nominees.length > 0 ? nominees.reduce((a, b) => (b.voteCount() || 0) > (a.voteCount() || 0) ? b : a) : null;

      // Check if user predicted correctly
      const isCorrect = userVotedNominee && winner && String(userVotedNominee.id()) === String(winner.id());
      results.push({
        category,
        userVotedNominee,
        winner,
        isCorrect: !!isCorrect
      });
    });
    return results;
  }
  view() {
    const award = this.attrs.award;
    const categories = this.attrs.categories;
    const results = this.getPredictionResults(award, categories);
    const votedResults = results.filter(r => r.userVotedNominee !== null);

    // Only show if user has voted in at least one category
    if (votedResults.length === 0) {
      return null;
    }
    const correctCount = votedResults.filter(r => r.isCorrect).length;
    const totalVoted = votedResults.length;
    const progressPercent = totalVoted > 0 ? correctCount / totalVoted * 100 : 0;
    const correctPredictions = votedResults.filter(r => r.isCorrect);
    const wrongPredictions = votedResults.filter(r => !r.isCorrect);
    return m("div", {
      className: "PredictionSummary"
    }, m("div", {
      className: "PredictionSummary-header"
    }, m("i", {
      className: "fas fa-bullseye"
    }), m("h3", null, app.translator.trans('huseyinfiliz-awards.forum.prediction.title'))), m("div", {
      className: "PredictionSummary-content"
    }, m("div", {
      className: "PredictionSummary-progress"
    }, m("div", {
      className: "PredictionSummary-progressTrack"
    }, m("div", {
      className: "PredictionSummary-progressFill",
      style: {
        width: `${progressPercent}%`
      }
    })), m("span", {
      className: "PredictionSummary-score"
    }, app.translator.trans('huseyinfiliz-awards.forum.prediction.score', {
      correct: correctCount,
      total: totalVoted
    }))), m("button", {
      className: "PredictionSummary-toggle",
      onclick: () => {
        this.showDetails = !this.showDetails;
        m.redraw();
      }
    }, this.showDetails ? m("span", null, m("i", {
      className: "fas fa-chevron-up"
    }), " Hide details") : m("span", null, m("i", {
      className: "fas fa-chevron-down"
    }), " Show details")), this.showDetails ? m("div", {
      className: "PredictionSummary-details"
    }, correctPredictions.length > 0 ? m("div", {
      className: "PredictionSummary-section PredictionSummary-section--correct"
    }, m("span", {
      className: "PredictionSummary-section-label"
    }, m("i", {
      className: "fas fa-check"
    }), " ", app.translator.trans('huseyinfiliz-awards.forum.prediction.correct')), m("div", {
      className: "PredictionSummary-categories"
    }, correctPredictions.map(r => m("span", {
      key: r.category.id(),
      className: "PredictionSummary-category"
    }, r.category.name())))) : null, wrongPredictions.length > 0 ? m("div", {
      className: "PredictionSummary-section PredictionSummary-section--wrong"
    }, m("span", {
      className: "PredictionSummary-section-label"
    }, m("i", {
      className: "fas fa-times"
    }), " ", app.translator.trans('huseyinfiliz-awards.forum.prediction.wrong')), m("div", {
      className: "PredictionSummary-categories"
    }, wrongPredictions.map(r => m("span", {
      key: r.category.id(),
      className: "PredictionSummary-category"
    }, r.category.name())))) : null) : null));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/PredictionSummary', PredictionSummary);